import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import DashboardShell from "../../components/layout/DashboardShell";
import { Pill } from "../../components/common/Primitives";
import AdminListSearch from "../../components/common/AdminListSearch";
import api from "../../lib/api";

export default function AdminDealRooms() {
  const [rows, setRows] = useState([]);
  const [query, setQuery] = useState("");
  useEffect(() => { api.get("/admin/deal-rooms").then((r) => setRows(r.data || [])); }, []);
  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return rows;
    return rows.filter((r) => {
      const hay = [r.deal_room_id, r.interest_id, r.stage, r.deal_summary,
                   r.investor_name, r.startup_name].filter(Boolean).join(" ").toLowerCase();
      return hay.includes(q);
    });
  }, [rows, query]);
  return (
    <DashboardShell title="Deal Rooms" subtitle="ADMIN · FACILITATION">
      <AdminListSearch
        value={query}
        onChange={setQuery}
        placeholder="Search by deal-room id, interest, stage, parties…"
        testId="admin-dealrooms-search"
        count={filtered.length}
      />
      <div className="border border-white/10 bg-white/70 backdrop-blur overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-[10px] uppercase tracking-widest text-ink-muted">
            <tr className="border-b border-white/10">
              <th className="text-left px-4 py-3">Deal Room</th>
              <th className="text-left px-4 py-3">Interest</th>
              <th className="text-left px-4 py-3">Stage</th>
              <th className="text-left px-4 py-3">Created</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((r) => (
              <tr key={r.deal_room_id} className="border-b border-white/5">
                <td className="px-4 py-3 text-ink font-mono text-xs">{r.deal_room_id}</td>
                <td className="px-4 py-3 text-ink-soft font-mono text-xs">{r.interest_id}</td>
                <td className="px-4 py-3"><Pill tone="gold">{r.stage}</Pill></td>
                <td className="px-4 py-3 text-ink-muted font-mono text-xs">{r.created_at?.slice(0, 10)}</td>
                <td className="px-4 py-3"><Link to={`/deal-room/${r.deal_room_id}`} className="text-gold text-xs font-heading">Open →</Link></td>
              </tr>
            ))}
            {filtered.length === 0 && (
              <tr><td colSpan={5} className="text-center py-10 text-ink-faint">
                {rows.length === 0 ? "No deal rooms yet." : "No deal rooms match your search."}
              </td></tr>
            )}
          </tbody>
        </table>
      </div>
    </DashboardShell>
  );
}
